import { cn } from '../../lib/cn';

type Metric = { label: string; value: string; change: string; positive: boolean };

type Props = {
  metrics?: Metric[];
};

export function ProductPerformanceStrip({ metrics = [] }: Props) {
  return (
    <div className="flex gap-3 overflow-x-auto pb-1">
      {metrics.map((m) => (
        <div
          key={m.label}
          className="min-w-[120px] shrink-0 rounded-lg border border-slate-200 bg-white px-4 py-3 dark:border-slate-700 dark:bg-slate-900"
        >
          <p className="text-xs text-slate-500">{m.label}</p>
          <p className="mt-0.5 text-lg font-semibold">{m.value}</p>
          <p className={cn(
            'text-xs font-medium',
            m.positive ? 'text-success-600' : 'text-error-600',
          )}>
            {m.change}
          </p>
        </div>
      ))}
    </div>
  );
}
